/**
 * quick-replies-route.tsx — Đường dẫn riêng /conversations/quick-replies: màn Hội thoại + popup quản lý Trả lời nhanh mở sẵn.
 * Là "chức năng độc lập" để phân quyền (`quick_replies.view`, PAGE_VIEW_PERM) và gửi link; đóng popup → về Hộp thư.
 * Trong khung chat, popup mở tại chỗ từ nút ⚡ → "Quản lý thư viện" (quick-messages-popover.tsx), không đổi trang.
 */
import { useEffect } from 'react'
import { Navigate, useNavigate } from 'react-router-dom'
import { toast } from 'sonner'
import { useTranslation } from 'react-i18next'
import { useMyPermissions } from '@/hooks/use-settings'
import { QUICK_REPLIES_PERM } from '@/hooks/use-quick-replies'
import { QuickRepliesDialog } from '@/pages/quick-replies/quick-replies-dialog'
import { ConversationsPage } from './conversations-page'

export function QuickRepliesRoute() {
  const { t } = useTranslation('quickReplies')
  const navigate = useNavigate()
  const { data: perms } = useMyPermissions()
  const denied = !!perms && !perms.has(QUICK_REPLIES_PERM)

  useEffect(() => {
    if (denied) toast.error(t('route.denied'))
  }, [denied, t])

  if (denied) return <Navigate to="/conversations" replace />
  return (
    <>
      <ConversationsPage />
      <QuickRepliesDialog open onOpenChange={(o) => !o && navigate('/conversations')} />
    </>
  )
}
